<template>
  <b-form>
    <div class="w-100 px-1">
      <b-row>
        <b-col cols="12" class="px-2 mb-1">
          <b-form-group
            :label="'Import File'"
            label-for="import-file"
            label-class="font-medium-5"
          >
            <b-row>
              <b-col cols="6" class="px-2 mb-1">
                <b-form-input
                  id="import-file"
                  class="import-file"
                  required
                  disabled
                  v-model="formFile.name"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="px-2 mb-1">
                <div  class="row justify-content-end">
                  <upload-button  @onUpload="onUpload"/>
                  <save-button
                    id="import"
                    :loading="loading.form"
                    @click.native="fetchInportUpdateCustomer"
                    :btnLabel="'Import'"
                    :disabled="!canUpload"
                    class="ml-1"
                  />
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>

<script>
import UploadButton from "@/views/components/button/UploadButton.vue";
import useImportUpdateCus from "../../hooks/useImportUpdateCus.js";

export default {
  components: { 
    UploadButton,
  },
  setup() {
    const {
      loading,
      formFile,
      canUpload,
      onUpload,
      downloadTemplate,
      fetchInportUpdateCustomer,
    } = useImportUpdateCus();
    return {
      loading,
      formFile,
      canUpload,
      onUpload,
      downloadTemplate,
      fetchInportUpdateCustomer,
    };
  },  
}
</script>

<style>

</style>


